import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Musaiyib Yakubu Usman </span>
            from <span className="purple"> Bauchi State, Nigeria.</span>
            <br />
            <i>I am graduating with my bachelor’s degree in computer science in January. I’m the Katsina State ICT director of the Nigerian Association Computing Students (NACOS), and gained hands-on experience working with UMG Tech Solutions and Strano Inc. I work well on teams, have excellent communication skills, and I’m currently looking for a full-time Software developer job.</i>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Bug Bounty Hunting
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Football
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Graphic Design and Motion Graphics
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Musaiyib (supplier)</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
